import { FolderOpenDot } from "lucide-react"
import { useNavigate } from "react-router-dom";

const ProjectCard = ({project,index}) => {
  const navigate = useNavigate();
  const isInactive = (updatedAt) => {
      if (!updatedAt) return false;
      const updatedDate = new Date(updatedAt);
      const currentDate = new Date();
      const oneMonthAgo = new Date();
      oneMonthAgo.setMonth(currentDate.getMonth() - 1);
      return updatedDate < oneMonthAgo;
  };
  const members = ['TV', 'M', '+2'];
  return (
            <div
              key={index}
              onClick={() => navigate(`/project_page/${project?._id}`)}
              className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 transition-all duration-200 ease-in-out hover:shadow-lg hover:border-blue-200 hover:scale-[1.02] cursor-pointer group"
            >
              <div className="flex items-start justify-between">
                <div className="flex items-center gap-4">
                  <div className="p-2 bg-gray-50 rounded-lg group-hover:bg-blue-50 transition-colors duration-200">
                    {/* {project?.icon} */}
                    <FolderOpenDot />
                  </div>
                  <div>
                    <h3 className="text-lg capitalize font-semibold text-gray-900 group-hover:text-blue-600 transition-colors duration-200">
                      {project?.project_name}
                    </h3>
                    <p className="text-sm text-gray-500">Last Updated on {project?.updatedAt}</p>
                    <p className="text-sm text-gray-500">Admin: {project?.admin}</p>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium transition-colors duration-200 ${
                    !isInactive(project?.updatedAt)
                      ? 'bg-green-100 text-green-800 group-hover:bg-green-200'
                      : 'bg-yellow-100 text-yellow-800 group-hover:bg-yellow-200'
                  }`}>
                    {isInactive(project?.updatedAt) ? 'Inactive' : 'Active'}
                  </span>
                </div>
              </div>
              {/* <div className="mt-4 flex items-center gap-1">
                {members?.map((member, index) => (
                  <span
                    key={index}
                    className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-gray-100 text-xs font-medium text-gray-600 transition-transform duration-200 hover:scale-110 hover:bg-blue-100 hover:text-blue-600"
                  >
                    {member}
                  </span>
                ))}
              </div> */}
            </div>
  )
}
export default ProjectCard